import React from 'react';
import PropTypes from 'prop-types';
// graphql
import gql from 'graphql-tag';
import { Query } from 'components/common/Query';
// our components
import SelectAgency from 'components/common/SelectAgency/SelectAgency';
import { userKinds } from 'config';

/**
 * Query to fetch agencies from api
 */
export const AGENCIES_QUERY = gql`
  query AgenciesList($userType: [FilterUserType]!) {
    adminUsers(userType: $userType) {
      edges {
        node {
          id
          fullname
        }
      }
    }
  }
`;

const SelectAgencyContainer = ({
  value,
  handleChange,
  errorText,
  disabled,
}) => (
  <Query
    query={AGENCIES_QUERY}
    variables={{ userType: userKinds.AGENCY }}
    fetchPolicy="cache-and-network"
  >
    {({ data, loading }) =>
      !loading && (
        <SelectAgency
          agencies={data}
          value={value}
          handleChange={handleChange}
          errorText={errorText}
          disabled={disabled}
        />
      )
    }
  </Query>
);

SelectAgencyContainer.propTypes = {
  value: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SelectAgencyContainer.defaultProps = {
  errorText: '',
  disabled: false,
};

export default SelectAgencyContainer;
